import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Carries "expand this state" signals from any component (e.g. AdminLayoutComponent
 * after views are loaded) to the sidebar expansion-panel components without
 * requiring direct DOM manipulation or @ViewChild chains.
 */
@Injectable({ providedIn: 'root' })
export class SideMenuService {
  private readonly _expand = new Subject<string>();
  readonly expand$ = this._expand.asObservable();

  expandSection(state: string): void {
    this._expand.next(state);
  }
}
